import React from 'react';

export default function MediaKit() {
  const mediaCategories = [
    {
      icon: 'ri-video-line',
      title: 'ZDJĘCIA I FILMY',
      description:
        'Profesjonalne zdjęcia i filmy w wysokiej rozdzielczości hotelu, pokoi, restauracji i usług.'
    },
    {
      icon: 'ri-book-2-line',
      title: 'KATALOGI',
      description:
        'Kompletne katalogi hotelu, golfa, spa i doświadczeń gastronomicznych gotowe do pobrania.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'ZRÓWNOWAŻONY ROZWÓJ',
      description:
        'Dokumentacja naszych inicjatyw ekologicznych, Eco Finca i zaangażowania w ochronę środowiska.'
    },
    {
      icon: 'ri-image-2-line',
      title: 'LOGO',
      description:
        'Oficjalne logo Hotel Jardín Tecina i Tecina Golf w różnych formatach.'
    }
  ];

  return (
    <section id="kit-media" className="py-24 px-6 bg-stone-50">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-stone-800 tracking-wider mb-4">
            MEDIA KIT
          </h2>
          <h3 className="text-xl md:text-2xl font-light text-stone-600 tracking-wide mb-6">
            HOTEL JARDÍN TECINA
          </h3>
          <div className="w-24 h-1 bg-stone-300 mx-auto mb-8"></div>
          <p className="text-stone-600 max-w-2xl mx-auto leading-relaxed">
            Uzyskaj dostęp do wszystkich materiałów promocyjnych, zdjęć, filmów, katalogów i logo hotelu oraz pola golfowego.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {mediaCategories.map((category, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-20 h-20 flex items-center justify-center border-2 border-stone-300 rounded-full mb-5 group-hover:border-stone-500 group-hover:bg-stone-100 transition-all duration-300">
                <i
                  className={`${category.icon} text-3xl text-stone-500 group-hover:text-stone-700 transition-colors`}
                ></i>
              </div>
              <h4 className="text-sm font-medium text-stone-700 tracking-wider mb-2">
                {category.title}
              </h4>
              <p className="text-xs text-stone-500 leading-relaxed hidden md:block">
                {category.description}
              </p>
            </div>
          ))}
        </div>

        {/* Download Button */}
        <div className="text-center">
          <a
            href="https://www.jardin-tecina.com/en/kit-media/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 bg-stone-800 text-white font-medium rounded-lg hover:bg-stone-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-cloud-2-line text-xl"></i>
            Pobierz Media Kit Hotel Jardín Tecina
          </a>
        </div>
      </div>
    </section>
  );
}
